import { AxiosResponse } from 'axios';
import { exportAllListEntries } from 'Services';
import { UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { RQ_GET_LIST_IMPORT_EXPORT_STATUS, callAll } from 'Utils';
import { useTranslation } from 'react-i18next';
import useAlertBanner from 'Hooks/reduxHelperHooks/useAlertBanner';
import useImportExportSuccessAlert from 'Routes/ListManagement/routes/hooks/useImportExportSuccessAlert';

type HookArgs = {
    mutationOptions?: UseMutationOptions<AxiosResponse, unknown, unknown, unknown>;
};
const useExportListEntries = ({ mutationOptions }: HookArgs) => {
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    const showSuccessAlert = useImportExportSuccessAlert();
    const { addAlert } = useAlertBanner();

    const defaultSuccessHandler = () => {
        const bannerTextMessage = t('Start List Export Success');
        const alertId = 'start-export-success';
        showSuccessAlert({ bannerTextMessage, alertId });
        queryClient.invalidateQueries([RQ_GET_LIST_IMPORT_EXPORT_STATUS]);
    };

    return useMutation(exportAllListEntries, {
        onSuccess: callAll(defaultSuccessHandler, mutationOptions?.onSuccess),
        onError: (error, variables, context) => {
            mutationOptions?.onError?.(error, variables, context);
            const errorAlertStatus = t('Start List Export Error');
            addAlert({
                id: 'start-export-error',
                status: 'danger',
                content: errorAlertStatus
            });
        }
    });
};

export default useExportListEntries;
